import Vue from 'vue'
import Vuex from 'vuex'
import tenantApi from '../api/tenant'
import { getAuthStorageItem, getValidToken, removeAuthStorageItem, setAuthStorageItem } from '../utils/authToken'

Vue.use(Vuex)

const DEFAULT_TENANT_BRAND = {
  scope: 'tenant',
  slug: 'redspider',
  name: '红蜘蛛集运',
  logoUrl: '/hzz_logo.jpg',
  brandColor: ''
}

function parseStoredTenantBrand() {
  try {
    return JSON.parse(getAuthStorageItem('tenant_brand') || 'null')
  } catch (e) {
    return null
  }
}

function normalizeTenantBrand(tenantBrand) {
  const next = Object.assign({}, DEFAULT_TENANT_BRAND, tenantBrand || {})
  const logoUrl = String(next.logoUrl || '').trim()
  if (logoUrl && !/^https?:\/\//i.test(logoUrl) && logoUrl.indexOf('//') !== 0 && logoUrl.charAt(0) !== '/') {
    next.logoUrl = `/${logoUrl}`
  }
  return next
}

export default new Vuex.Store({
  state: {
    user: JSON.parse(getAuthStorageItem('user') || 'null'),
    token: getValidToken(),
    tenantBrand: normalizeTenantBrand(parseStoredTenantBrand())
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
      setAuthStorageItem('user', JSON.stringify(user))
    },
    SET_TOKEN(state, token) {
      state.token = token
      setAuthStorageItem('token', token)
    },
    SET_TENANT_BRAND(state, tenantBrand) {
      state.tenantBrand = normalizeTenantBrand(tenantBrand)
      setAuthStorageItem('tenant_brand', JSON.stringify(state.tenantBrand))
    },
    LOGOUT(state) {
      state.user = null
      state.token = ''
      removeAuthStorageItem('user')
      removeAuthStorageItem('token')
    }
  },
  actions: {
    async loadTenantBrand({ commit }) {
      try {
        const tenantBrand = await tenantApi.getPublicTenant()
        commit('SET_TENANT_BRAND', tenantBrand)
        if (tenantBrand && tenantBrand.scope === 'tenant' && tenantBrand.name) {
          document.title = tenantBrand.name
        }
        return tenantBrand
      } catch (e) {
        return null
      }
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  }
})
